import React from 'react'
import { useSelector } from 'react-redux'
import './container.css'

const Loading = () => {
  const loading = useSelector((state) => state.loading)

  if (loading) {
    return (
      <div
        className="d-flex justify-content-between align-items-center"
        style={{
          position: 'absolute',
          width: '100vw',
          height: '100vh',
          zIndex: 9999,
          backgroundColor: 'rgba(0, 0, 0, 0.4)',
        }}
      >
        <div className='spinner' style={{ width: '4rem', height: '4rem', margin: '0 auto' }} />
      </div>
    )
  } else {
    return <></>
  }
}

export default Loading
